<template>
  <div>
    <loader-dialog :is-dialog-visible="isDialogVisible2" />
    <v-card class="mb-8">
      <div class="m-2">
        <v-row class="ml-5 mr-5">
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="$store.state.locked.field.keyword"
              label="Rechercher globalement"
              outlined
              dense
              placeholder="Rechercher globalement"
              hide-details
              clearable
              @input="filterElts"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card>
      <v-data-table
        :loading="isDialogVisible"
        loading-text="Chargement..."
        :headers="headers"
        :items="$store.getters['locked/lockeds']"
        :items-per-page="$store.getters['locked/per_page']"
        :page.sync="$store.getters['locked/current_page']"
        dense
        fixed-header
        height="500"
        hide-default-footer
        @page-count="currentPage = $event"
      >
        <template #[`item.created_at`]="{item}">
          {{ formattingDate(`${item.created_at}`) }}
        </template>
        <template #[`item.is_active`]="{item}">
          <v-chip
            small
            :color="item.is_active ? 'primary' : 'error'"
            :class="`${item.is_active ? 'primary' : 'error'}--text`"
            class="v-chip-light-bg"
          >
            {{ item.is_active === true ? 'OUI' : 'NON' }}
          </v-chip>
        </template>
      </v-data-table>

      <v-card-text class="pt-2">
        <v-row>
          <v-col
            lg="2"
            cols="3"
          >
            <v-text-field
              :value="$store.state.locked.field.paginate"
              label="Lignes par page:"
              type="number"
              min="-1"
              max="15"
              hide-details
              @input="getEltsPerPage"
            ></v-text-field>
          </v-col>

          <v-col
            lg="10"
            cols="9"
            class="d-flex justify-end"
          >
            <v-pagination
              v-model="currentPage"
              total-visible="6"
              :length="lastPage"
              @input="getElts"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import LoaderDialog from '@core/components/dialogs/LoaderDialog'
import { formatDate } from '@core/date/dateFunctions'
import { ref, onMounted } from '@vue/composition-api'
import {
  mdiAccountLock,
  mdiDeleteOutline,
  mdiDotsVertical, mdiEyeOutline, mdiLockOpen,
  mdiPencilOutline, mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import store from '@/store'

export default {
  name: 'UserLocksList',

  components: { LoaderDialog },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    user_id: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const currentPage = ref(null)
    const lastPage = ref(null)
    const dialogDelete = ref(false)
    const isDialogVisible = ref(false)
    const isDialogVisible2 = ref(false)
    const dialog = ref(false)
    const isLockedColor = {
      false: 'info',
      true: 'success',
    }

    const formattingDate = date => formatDate(date)

    const getElts = (page = 1) => {
      isDialogVisible.value = true
      store.state.locked.field.user_id = props.user_id
      store.dispatch('locked/getLockedsList', { page, field: store.state.locked.field }).then(() => {
        currentPage.value = store.getters['locked/current_page']
        lastPage.value = store.getters['locked/last_page']
        isDialogVisible.value = false
      })
    }

    const filterElts = () => {
      setTimeout(() => {
        getElts()
      }, 1000)
    }

    // eslint-disable-next-line camelcase
    const getEltsPerPage = per_page => {
      // eslint-disable-next-line camelcase
      if (per_page !== null) {
        isDialogVisible.value = true
        // eslint-disable-next-line camelcase
        store.state.locked.field.paginate = per_page
        store.state.locked.field.user_id = props.user_id
        store.dispatch('locked/getLockedsList', {
          page: currentPage.value,
          field: store.state.locked.field,
        }).then(() => {
          currentPage.value = store.getters['locked/current_page']
          lastPage.value = store.getters['locked/last_page']
          isDialogVisible.value = false
        })
      }
    }

    const loading = () => {
      isDialogVisible.value = !isDialogVisible.value
    }

    onMounted(() => {
      getElts(store.getters['locked/current_page'])
    })

    return {
      filterElts,
      loading,
      getEltsPerPage,
      getElts,
      formattingDate,
      currentPage,
      lastPage,
      dialogDelete,
      isDialogVisible,
      isDialogVisible2,
      dialog,
      headers: [
        { text: 'RAISON', value: 'reason' },
        { text: 'ACTIF?', value: 'is_active' },
        { text: 'DATE DE CREATION', value: 'created_at' },
      ],
      itemsPerPage: 10,
      status: {
        1: 'Current',
        2: 'Professional',
        3: 'Rejected',
        4: 'Resigned',
        5: 'Applied',
      },
      is_locked: {
        1: true,
        2: false,
      },
      isLockedColor,

      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPencilOutline,
        mdiAccountLock,
        mdiLockOpen,
        mdiPlus,
        mdiEyeOutline,
      },
    }
  },
}
</script>

<style scoped>

</style>
